import { render, staticRenderFns } from "./ConstructionDocumentation.vue?vue&type=template&id=14d48b5e&scoped=true&lang=pug&"
import script from "./ConstructionDocumentation.vue?vue&type=script&lang=ts&"
export * from "./ConstructionDocumentation.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionDocumentation.vue?vue&type=style&index=0&id=14d48b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d48b5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
